import React from 'react'
import { ErrorMessage, Field, Form, Formik, FormikActions } from 'formik'
import loadingBox from '../../assets/images/loading_box.gif'
import { SetNotification } from '../../contexts/NotificationProvider'
import { ITSError } from '../Layout/ITSError'
import { ObjectSchema } from 'yup'

export interface Batch {
  articleNo: string
  batchNo: string
  endSerial: string
  orderNo: string
  qty: string
  startSerial: string
  [index: string]: any
}

export interface BatchTracingFormValues {
  searchByProperty: string
  searchByPropertyValue: string
}

interface Props {
  searchTypes: Record<string, string>
  setNotification: SetNotification
  batchTracingFormValidationSchema: ObjectSchema<BatchTracingFormValues>
  batchTracingFormInitialValues: {
    searchByProperty: string
    searchByPropertyValue: string
  }
  handleSubmit: (values: BatchTracingFormValues, actions: FormikActions<BatchTracingFormValues>) => void
  isFetchingData: boolean
}

export const BatchTracingForm: React.FunctionComponent<Props> = ({
  searchTypes,
  batchTracingFormValidationSchema,
  batchTracingFormInitialValues,
  handleSubmit,
  isFetchingData,
}) => {
  return (
    <Formik
      initialValues={batchTracingFormInitialValues}
      validationSchema={batchTracingFormValidationSchema}
      enableReinitialize={true}
      isInitialValid={({ initialValues }: any) => batchTracingFormValidationSchema.isValidSync(initialValues)}
      onSubmit={handleSubmit}
      render={({ isSubmitting, isValid, values }) => {
        return (
          <>
            <div className="row">
              <div className="col-md-offset-3 col-md-6">
                <div className="panel reference-box">
                  <div className="panel-heading">Batch Number Tracing</div>
                  <div className="panel-body">
                    <Form>
                      <Field
                        component="select"
                        name="searchByProperty"
                        title="Search by property"
                        id="batch-search-by-property"
                        className="dw-input"
                      >
                        {Object.entries(searchTypes).map(([searchType, displayName]) => (
                          <option value={searchType} key={searchType}>
                            {displayName}
                          </option>
                        ))}
                      </Field>
                      <Field
                        type="text"
                        name="searchByPropertyValue"
                        className="form-control dw-input"
                        required
                        placeholder={`Search for ${searchTypes[values.searchByProperty]}`}
                      />
                      <ErrorMessage
                        name="searchByPropertyValue"
                        render={errorMessage => <ITSError errorMessage={errorMessage} />}
                      />
                      {!(isSubmitting || isFetchingData) ? (
                        <button type="submit" className="btn btn-default dw-btn" id="search-btn" disabled={!isValid}>
                          Search
                        </button>
                      ) : (
                        <img src={loadingBox} className="loading" alt="loading" />
                      )}
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }}
    />
  )
}
